import { ProximityToolDrawer as View } from "ui-components";

import { useCloseMapTool } from "~map-view/states";

const LAYERS = [
	{ id: "layer1", name: "College and University" },
	{ id: "layer2", name: "Roads" },
	{ id: "layer3", name: "Counties" },
];

export const ProximityToolDrawer = () => {
	const closeMapTool = useCloseMapTool();

	return (
		<View
			onClose={closeMapTool}
			layers={LAYERS}
		/>
	);
};
